export default "__VITE_ASSET__Hy5huCL___"